// FIXME: Fix this the next time the file is edited.
import { useState } from "react";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const supportsLocalStorage = () => {
  try {
    return !!window.localStorage;
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return false;
  }
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const getItem = (name: any) => {
  if (!supportsLocalStorage()) {
    return null;
  }

  try {
    const value = window.localStorage.getItem(name);

    try {
      // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
      return JSON.parse(value);
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return value;
    }
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return null;
  }
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const saveItem = (name: any, value: any) => {
  if (!supportsLocalStorage()) {
    return false;
  }

  const toSave = typeof value !== "string" ? JSON.stringify(value) : value;

  try {
    window.localStorage.setItem(name, toSave);
    return true;
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return false;
  }
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const removeItem = (name: any) => {
  if (!supportsLocalStorage()) {
    return false;
  }

  try {
    window.localStorage.removeItem(name);
    return true;
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return false;
  }
};

export const useLocalStorageSync = <T>(entry: string, defaultValue: T): [T, (value: T) => void] => {
  const [value, setValue] = useState(getItem(entry) || defaultValue);

  const setLocalStorageValue = (value: T): void => {
    setValue(value);
    saveItem(entry, value);
  };

  return [value, setLocalStorageValue];
};
